import { render } from "./EditFile.vue?vue&type=template&id=48a69288&scoped=true"
import script from "./EditFile.vue?vue&type=script&lang=js"
export * from "./EditFile.vue?vue&type=script&lang=js"

import "./EditFile.vue?vue&type=style&index=0&id=48a69288&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a69288"]])

export default __exports__